export * from './fps-panel';
export * from './textures-panel';
export * from './programs-panel';
export * from './draw-calls-panel';
export * from './gpu-mem-panel';